import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
  initialState,
} from '../../../utils/redux';

export const consts = createReqConsts('patient', 'update-patient-insurance', [
  'CLEAR_ERROR',
]);

export const actions = createActions(consts);

export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'users',
  type: 'put',
  slug: [
    {
      type: 'payload',
      selector: ['userId'],
    },
    'patient_insurances',
    {
      type: 'payload',
      selector: ['patientInsuranceId'],
    },
  ],
});

const reqReducer = createReqReducer(consts);

export default (state = initialState, action) => {
  const { type } = action;

  switch (type) {
    case consts.CLEAR_ERROR:
      return {
        ...state,
        error: null,
      };
    default:
      return reqReducer(state, action);
  }
};



// WEBPACK FOOTER //
// ./src/redux/manage-insurances/requests/update-patient-insurance.js